import { ButtonHTMLAttributes, ComponentProps, DetailedHTMLProps } from 'react';
import { Button } from '@consta/uikit/Button';
import * as icons from '@ui/icons';
import styles from './styles.module.css';
import { CrossIcon } from '@@/common/icons/cross.icon';

type Icons = keyof typeof icons;

type ButtonBaseProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

type ButtonWithIconProps = {
  iconPosition?: 'left' | 'right';
  iconFill?: string;
  icon: Icons | ((...props: any) => JSX.Element);
  loading?: boolean;
} & ButtonBaseProps;

type ButtonIconProps = Omit<ButtonBaseProps, 'children'>;

/**
 * @deprecated
 * @see UiButton
 */
const ButtonBase = ({ children, className = '', ...props }: ButtonBaseProps) => (
  <button type="button" className={`${styles.button} ${className}`} {...props}>
    {children}
  </button>
);

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonPrimary = (props: Omit<ComponentProps<typeof Button>, 'view'>) => (
  <Button view="primary" {...props} />
);

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonSecondary = (props: Omit<ComponentProps<typeof Button>, 'view'>) => (
  <Button view="secondary" {...props} />
);

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonDanger = (props: ButtonBaseProps) => (
  <ButtonBase className={styles.buttonDanger} {...props}>
    {props.children}
  </ButtonBase>
);

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonIconBase = ({
  children,
  className = '',
  ...props
}: ButtonBaseProps) => (
  <button type="button" className={`${styles.buttonIcon} ${className}`} {...props}>
    {children}
  </button>
);

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonWithIcon = ({
  children,
  icon,
  iconFill,
  loading = false,
  className = '',
  iconPosition = 'right',
  ...props
}: ButtonWithIconProps) => {
  const Icon = loading
    ? icons['Refresh']
    : typeof icon === 'string'
    ? icons[icon]
    : icon;

  return (
    <button
      type="button"
      data-icon-position={iconPosition}
      className={`${styles.button} ${styles.buttonWithIcon} ${className}`}
      {...props}
    >
      {children}
      <Icon fill={iconFill} />
    </button>
  );
};

/**
 * @deprecated
 * @see UiButton
 */
export const ButtonClose = (props: ButtonIconProps) => (
  <ButtonIconBase {...props}>
    <CrossIcon />
  </ButtonIconBase>
);
